export default {
  // Sorts a list of questions based on leading question ids
  //   - When a loop is detected, the list will attempt to be sorted anyway:
  //     - If eventBus is provided, a notification is logged to the UI
  //     - If eventBus is not provided, an error is logged to the console
  // @param list - array of questions
  // @param eventBus - event bus for error notification (optional)
  // @returns sorted array of questions
  sort(list, eventBus = null) {
    if (!list || list.length === 0) {
      return [];
    }
    if (list.length === 1) {
      return list;
    }

    const tallies = list.reduce((tally, item) => {
      tally[item.leading_question_id] = (tally[item.leading_question_id] || 0) + 1;
      return tally;
    }, {});

    const hasLoop = Object.values(tallies).some((tally) => tally > 1);
    if (hasLoop) {
      if (eventBus) {
        eventBus.error('Loop detected');
      } else {
        console.error('Loop detected');
      }
    }

    // Finds single element without a leading question id
    // Uses 'filter' instead of 'find' for easier vitest testing
    let newList = list.filter((item) => !item.leading_question_id);
    let counter = 0;
    const breakLimit = 1000;

    while (counter < breakLimit) {
      if (newList.length === list.length) break;
      const currentItem = newList[counter];

      const followingItem = list.find((item) => item.leading_question_id === currentItem.id);

      if (followingItem) newList.splice(counter + 1, 0, followingItem);

      counter += 1;
    }
    return newList;
  },
};
